import { createElement, useState } from "react";
import { type ReactElement } from "react";
import { pdf, type DocumentProps } from "@react-pdf/renderer";
import SovPdf, { SovPdfProps } from "Components/Common/SovPdf/SovPdf";

const buildElement = (data: SovPdfProps) =>
  createElement(SovPdf, data) as ReactElement<DocumentProps>;

export const sovPdfFileName = (projectName?: string) =>
  `SOV-${projectName ?? "export"}-${new Date().toISOString().slice(0, 10)}.pdf`;

/** Returns the raw PDF Blob — use this when you need to upload before submitting. */
export const generatePdfBlob = (data: SovPdfProps): Promise<Blob> =>
  pdf(buildElement(data)).toBlob();

export const useSovPdf = () => {
  const [isExportingPdf, setIsExportingPdf] = useState(false);

  const exportPdf = async (data: SovPdfProps) => {
    setIsExportingPdf(true);
    try {
      const blob = await generatePdfBlob(data);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = sovPdfFileName(data.projectName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } finally {
      setIsExportingPdf(false);
    }
  };

  return { exportPdf, isExportingPdf };
};
